import { ESuggestedProductType, ESuggestedProductViewId } from 'core/model/enums/catalog.enum';
import { EChannel } from 'core/model/enums/channel.enum';
import {
  ICatalogSortOption,
  TSectionsSuggestionConfig,
  TSuggestedSectionsTypes,
} from 'core/model/interfaces/catalogues.interface';

export const CATALOGUE_SORT_OPTIONS: Array<ICatalogSortOption> = [
  {
    id: 'recommended',
    content: 'Recomendado',
    value: 'recommended:asc',
  },
  {
    id: 'name',
    content: 'A-Z',
    value: 'name:asc',
  },
  {
    id: 'lowerPrice',
    content: 'Menor precio',
    value: 'price:asc',
  },
  {
    id: 'higherPrice',
    content: 'Mayor precio',
    value: 'price:desc',
  },
];

export const DEFAULT_CATALOG_PAGE = 1;
export const DEFAULT_CATALOG_ITEMS_PER_PAGE = 12;
export const MAX_SUGGESTED_ITEMS_PER_PAGE = 24;
export const PRODUCT_COUNTER_CLICKING_DELAY = 700;

export const DEBOUNCE_TIME_TO_FETCH_SUGGESTION_PRODUCTS = 10000;

export const SUGGESTIONS_TITLES: Record<TSuggestedSectionsTypes, string> = {
  I: 'Tus productos favoritos de siempre',
  X: 'Tus productos favoritos de siempre',
  Z: 'Otros clientes están comprando estos productos',
  P: 'Otros clientes están comprando estos productos',
};

export const SECTIONS_SUGGESTION_CONFIG_FOR_DEX: TSectionsSuggestionConfig = {
  [ESuggestedProductViewId.homepage]: {
    [EChannel.DIADIA]: [ESuggestedProductType.X],
    [EChannel.INSUMA]: [ESuggestedProductType.I],
    [EChannel.ALICORP]: [ESuggestedProductType.I],
  },
  [ESuggestedProductViewId.shoppingCart]: {
    [EChannel.DIADIA]: [ESuggestedProductType.Z],
    [EChannel.INSUMA]: [ESuggestedProductType.Z],
    [EChannel.ALICORP]: [ESuggestedProductType.Z],
  },
  [ESuggestedProductViewId.internalPage]: {
    [EChannel.DIADIA]: [ESuggestedProductType.X, ESuggestedProductType.Z],
    [EChannel.INSUMA]: [ESuggestedProductType.I, ESuggestedProductType.Z],
    [EChannel.ALICORP]: [ESuggestedProductType.I, ESuggestedProductType.Z],
  },
};
export const SECTIONS_SUGGESTION_CONFIG_FOR_APUDEX: TSectionsSuggestionConfig = {
  [ESuggestedProductViewId.homepage]: {
    [EChannel.DIADIA]: [ESuggestedProductType.I],
    [EChannel.INSUMA]: [ESuggestedProductType.I],
    [EChannel.ALICORP]: [ESuggestedProductType.I],
  },
  [ESuggestedProductViewId.shoppingCart]: {
    [EChannel.DIADIA]: [ESuggestedProductType.P],
    [EChannel.INSUMA]: [ESuggestedProductType.P],
    [EChannel.ALICORP]: [ESuggestedProductType.P],
  },
  [ESuggestedProductViewId.internalPage]: {
    [EChannel.INSUMA]: [ESuggestedProductType.I, ESuggestedProductType.P],
    [EChannel.DIADIA]: [ESuggestedProductType.I, ESuggestedProductType.P],
    [EChannel.ALICORP]: [ESuggestedProductType.I, ESuggestedProductType.P],
  },
};

export const SUGGESTION_SECTION_TITLES: Record<ESuggestedProductType, string> = {
  [ESuggestedProductType.I]: SUGGESTIONS_TITLES.I,
  [ESuggestedProductType.P]: SUGGESTIONS_TITLES.P,
  [ESuggestedProductType.X]: SUGGESTIONS_TITLES.X,
  [ESuggestedProductType.Z]: SUGGESTIONS_TITLES.Z,
};
